import { RouteObject } from "react-router-dom";
import { PageLayoutDefaultMenuNavigationGroup } from "@sis/react-library"
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import { FormSamplesAboutPage } from "./formSamplesPages/FormSamplesAboutPage";
import { FormSamplesBasicPage } from "./formSamplesPages/formSamplesBasicPage/FormSamplesBasicPage";
import { FormSamplesCustomControlPage } from "./formSamplesPages/formSamplesCustomControlPage/FormSamplesCustomControlPage";
import { FormSamplesFormOnlyFieldsPage } from "./formSamplesPages/formSamplesFormOnlyFieldsPage/FormSamplesFormOnlyFieldsPage";
import { FormSamplesCustomLayoutPage } from "./formSamplesPages/formSamplesCustomLayoutPage/FormSamplesCustomLayoutPage";
import { FormSamplesDifferentControlsPage } from "./formSamplesPages/formSamplesDifferentControlsPage/FormSamplesDifferentControlsPage";
import { FormSamplesInitialValuesPage } from "./formSamplesPages/formSamplesInitialValuesPage/FormSamplesInitialValuesPage";
import { FormSamplesSettingValuesDynamicallyPage } from "./formSamplesPages/formSamplesSettingValuesDynamicallyPage/FormSamplesSettingValuesDynamicallyPage";
import { FormSamplesSubmitButtonOnlyPage } from "./formSamplesPages/formSamplesSubmitButtonOnlyPage/FormSamplesSubmitButtonOnlyPage";
import { FormSamplesValidationPage } from "./formSamplesPages/formSamplesValidationPage/FormSamplesValidationPage";
import { FormSamplesDisableFormPage } from "./formSamplesPages/formSamplesDisableFormPage/FormSamplesDisableFormPage";
import { FormSamplesControlsNotUsingFormPage } from "./formSamplesPages/formSamplesControlsNotUsingFormPage/FormSamplesControlsNotUsingFormPage";
import { FormSamplesNoFeedbackPage } from "./formSamplesPages/formSamplesNoFeedbackPage/FormSamplesNoFeedbackPage";
import { FormSamplesWithinDialogPage } from "./formSamplesPages/formSamplesWithinDialogPage/FormSamplesWithinDialogPage";
import { FormSamplesNonFieldtemsPage } from "./formSamplesPages/formSamplesNonFieldtemsPage/FormSamplesNonFieldtemsPage";
import { FormSamplesFormGroupsPage } from "./formSamplesPages/formSamplesFormGroupsPage/FormSamplesFormGroupsPage";
import { FormSamplesErrorsPage } from "./formSamplesPages/formSamplesErrorsPage/FormSamplesErrorsPage";

const url = "formSamples";

// Allow in same file
// eslint-disable-next-line
export const formSamplesRoutes = {
    about: `/${url}/about`,
    basic: `/${url}/basic`,
    initialValues: `/${url}/initialValues`,
    differentControls: `/${url}/differentControls`,
    validation: `/${url}/validation`,
    formErrors: `/${url}/formErrors`,
    setValuesDynamically: `/${url}/setValuesDynamically`,
    formGroups: `/${url}/formGroups`,
    submitButtonOnly: `/${url}/submitButtonOnly`,
    customLayout: `/${url}/customLayout`,
    customControl: `/${url}/customControl`,
    formOnlyFields: `/${url}/formOnlyFields`,
    disableForm: `/${url}/disableForm`,
    noFeedback: `/${url}/noFeedback`,
    withinDialog: `/${url}/withinDialog`,
    nonFieldItems: `/${url}/nonFieldItems`,
    controlsNotUsingForm: `/${url}/controlsNotUsingForm`
}

export const FormSamplesNavigation = (): RouteObject[] => {
    return [
        {
            path: formSamplesRoutes.about,
            element: <FormSamplesAboutPage />
        },
        {
            path: formSamplesRoutes.basic,
            element: <FormSamplesBasicPage />
        },
        {
            path: formSamplesRoutes.initialValues,
            element: <FormSamplesInitialValuesPage />
        },
        {
            path: formSamplesRoutes.differentControls,
            element: <FormSamplesDifferentControlsPage />
        },
        {
            path: formSamplesRoutes.validation,
            element: <FormSamplesValidationPage />
        },
        {
            path: formSamplesRoutes.formErrors,
            element: <FormSamplesErrorsPage />
        },
        {
            path: formSamplesRoutes.setValuesDynamically,
            element: <FormSamplesSettingValuesDynamicallyPage />
        },
        {
            path: formSamplesRoutes.formGroups,
            element: <FormSamplesFormGroupsPage />
        },
        {
            path: formSamplesRoutes.submitButtonOnly,
            element: <FormSamplesSubmitButtonOnlyPage />
        },
        {
            path: formSamplesRoutes.customLayout,
            element: <FormSamplesCustomLayoutPage />
        },
        {
            path: formSamplesRoutes.customControl,
            element: <FormSamplesCustomControlPage />
        },
        {
            path: formSamplesRoutes.formOnlyFields,
            element: <FormSamplesFormOnlyFieldsPage />
        },
        {
            path: formSamplesRoutes.disableForm,
            element: <FormSamplesDisableFormPage />
        },
        {
            path: formSamplesRoutes.noFeedback,
            element: <FormSamplesNoFeedbackPage />
        },
        {
            path: formSamplesRoutes.withinDialog,
            element: <FormSamplesWithinDialogPage />
        },
        {
            path: formSamplesRoutes.nonFieldItems,
            element: <FormSamplesNonFieldtemsPage />
        },
        {
            path: formSamplesRoutes.controlsNotUsingForm,
            element: <FormSamplesControlsNotUsingFormPage />
        }
    ]
}

// Allow in same file
// eslint-disable-next-line
export const FormSamplesMenuItem: PageLayoutDefaultMenuNavigationGroup = {
    icon: <TextSnippetIcon />, text: 'Form', items: [
        { text: 'About', navigateTo: formSamplesRoutes.about },
        { text: 'Basic', navigateTo: formSamplesRoutes.basic },
        { text: 'Initial Values', navigateTo: formSamplesRoutes.initialValues },
        { text: 'Different Controls', navigateTo: formSamplesRoutes.differentControls },
        { text: 'Validation', navigateTo: formSamplesRoutes.validation },
        { text: 'Form Errors', navigateTo: formSamplesRoutes.formErrors },
        { text: 'Set Values Dynamically', navigateTo: formSamplesRoutes.setValuesDynamically },
        { text: 'Form Groups', navigateTo: formSamplesRoutes.formGroups },
        { text: 'Submit Button Only', navigateTo: formSamplesRoutes.submitButtonOnly },
        { text: 'Custom Layout', navigateTo: formSamplesRoutes.customLayout },
        { text: 'Custom Control', navigateTo: formSamplesRoutes.customControl },
        { text: 'Form Only Fields', navigateTo: formSamplesRoutes.formOnlyFields },
        { text: 'Disable Form', navigateTo: formSamplesRoutes.disableForm },
        { text: 'No Feedback', navigateTo: formSamplesRoutes.noFeedback },
        { text: 'Within a Dialog', navigateTo: formSamplesRoutes.withinDialog },
        { text: 'Non Field Items', navigateTo: formSamplesRoutes.nonFieldItems },
        { text: 'Controls Not Using Form', navigateTo: formSamplesRoutes.controlsNotUsingForm }
    ]
}
